import React, { Suspense, lazy } from 'react';
import { client } from './client/apollo';
import { Route, Switch } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from 'react-apollo';
// components
import Footer from './components/views/partial/Footer';
import Loader from './components/views/partial/Loader';
// styles
import GlobalStyle from './assets/fonts/fonts';
import { ThemeProvider } from 'styled-components';
import { theme } from './theme';
import './main.css';
import { MainApp } from './AppStyles';
// context
import { ApiDataContextProvider } from './context/ApiDataContext';
import { GlobalContextProvider } from './context/GlobalContext';
// services
import UseGoogleAnalytics from './hooks/useGoogleAnalytics';

const Landing = lazy(() => import('./components/views/Landing'));
const Result = lazy(() => import('./containers/ProductContainer'));

function Routes() {
  UseGoogleAnalytics();

  return (
    <Suspense fallback={<Loader />}>
      <Switch>
        <Route exact path="/">
          <Landing />
        </Route>
        <ApiDataContextProvider>
          <Route exact path="/result">
            <Result />
          </Route>
        </ApiDataContextProvider>
      </Switch>
    </Suspense>
  );
}

function App() {
  return (
    <ThemeProvider theme={{ ...theme, fontFamily: 'BootsSharp' }}>
      <MainApp>
        <GlobalContextProvider>
          <ApolloProvider client={client}>
            <BrowserRouter>
              <GlobalStyle />
              <Routes />
              <Footer />
            </BrowserRouter>
          </ApolloProvider>
        </GlobalContextProvider>
      </MainApp>
    </ThemeProvider>
  );
}

export default App;
